// =============================================
// DON WIDGET — Logique du formulaire de don
// =============================================

(function () {
  var _dwAmt = 100;
  var _dwType = 'unique';

  function dwType(t) {
    _dwType = t;
    var u = document.getElementById('dw-unique');
    var m = document.getElementById('dw-mensuel');
    if (!u || !m) return;
    if (t === 'unique') {
      u.style.background = '#b5e830'; u.style.color = '#0c0f0a';
      m.style.background = 'transparent'; m.style.color = 'rgba(255,255,255,.45)';
    } else {
      m.style.background = '#b5e830'; m.style.color = '#0c0f0a';
      u.style.background = 'transparent'; u.style.color = 'rgba(255,255,255,.45)';
    }
  }

  function dwAmt(btn, v) {
    _dwAmt = v;
    var free = document.getElementById('dw-free');
    if (free) free.value = '';
    document.querySelectorAll('.don-amt-btn').forEach(function (b) {
      b.classList.remove('sel');
    });
    btn.classList.add('sel');
    dwTax();
  }

  function dwFree(v) {
    _dwAmt = parseFloat(v) || 0;
    document.querySelectorAll('.don-amt-btn').forEach(function (b) {
      b.classList.remove('sel');
    });
    dwTax();
  }

  function dwTax() {
    var el = document.getElementById('dw-tax');
    if (el) el.textContent = Math.round(_dwAmt * 0.34) + ' €';
  }

  function dwStripe() {
    if (!_dwAmt || _dwAmt < 1) { alert('Veuillez choisir un montant.'); return; }
    var btn = document.querySelector('.don-btn-card');
    if (btn) { btn.textContent = 'Chargement…'; btn.disabled = true; }
    fetch('https://www.compack.io/api/checkout.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: _dwAmt, type: _dwType })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Erreur : ' + (data.error || 'réessayez.'));
        if (btn) { btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="1" y="1" width="22" height="16" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/><rect x="1" y="6" width="22" height="3" fill="currentColor" opacity=".5"/><rect x="3" y="13" width="7" height="2" rx="1" fill="currentColor"/></svg> Payer par carte'; btn.disabled = false; }
      }
    })
    .catch(function () {
      alert('Erreur réseau, veuillez réessayer.');
      if (btn) { btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="1" y="1" width="22" height="16" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/><rect x="1" y="6" width="22" height="3" fill="currentColor" opacity=".5"/><rect x="3" y="13" width="7" height="2" rx="1" fill="currentColor"/></svg> Payer par carte'; btn.disabled = false; }
    });
  }

  function dwPayPal() {
    if (!_dwAmt || _dwAmt < 1) { alert('Veuillez choisir un montant.'); return; }
    var btn = document.querySelector('.don-btn-pp');
    if (btn) { btn.textContent = 'Chargement…'; btn.disabled = true; }
    fetch('https://www.compack.io/api/paypal.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: _dwAmt, type: _dwType })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Erreur : ' + (data.error || 'réessayez.'));
        if (btn) { btn.textContent = 'PayPal'; btn.disabled = false; }
      }
    })
    .catch(function () {
      alert('Erreur réseau, veuillez réessayer.');
      if (btn) { btn.textContent = 'PayPal'; btn.disabled = false; }
    });
  }

  // Expose globally (used by onclick attributes)
  window.dwType  = dwType;
  window.dwAmt   = dwAmt;
  window.dwFree  = dwFree;
  window.dwStripe = dwStripe;
  window.dwPayPal = dwPayPal;

  // Init tax display on load
  dwTax();
})();
